export default __webpack_public_path__ + "static/media/weather.ea6626e4.png";